// Plugin PWA deshabilitado completamente
export default {
  install(app) {
    // Plugin vacío - PWA completamente deshabilitada
    console.log('PWA completamente deshabilitada');
  }
} 